import { PRODUCT_APPROVAL_TYPE, APPROVAL_TYPE } from '../constants/patientChart.constant';

export const isCancelled = ({
  status = '',
}) => (status === PRODUCT_APPROVAL_TYPE.Cancelled);

export const isMedicallyDenied = ({
  status = '',
}) => (status === PRODUCT_APPROVAL_TYPE.MedicallyDenied);

export const isCancelledOrMedicallyDenied = ({
  status = '',
}) => (isCancelled({ status }) || isMedicallyDenied({ status }));

/**
 * 
 * @param {{
 *    OrderDate: string;
 *    OrderId: string;
 *    OrderStatus: string;
 *    Products: {}[];
 * }[]} orders 
 * @returns {boolean}
 */
export const hasFullfilledOrder = (orders = []) => {
  const orderIndex = orders.findIndex((order) => order.OrderStatus === APPROVAL_TYPE.fullfilled);
  return orderIndex > -1;
};
